export const CURRENT_PRICE = '$6.39'
export const ORIGINAL_PRICE = '$40'
export const DISCOUNT_PERCENT = '84%'
export const CHECKOUT_URL = 'https://epikkastore.com/cart/44917431238679:1'
